import { FC } from 'react';
import { Button, LinkButton } from 'src/components';
import { defineMessages, useIntl } from 'react-intl';
import { ROUTES } from 'src/constants/routes.const';
import { useRouter } from 'next/router';
import * as S from './styles';

const msgs = defineMessages({
  emptyTitle: { id: 'wordlists_addedbyme_emptystate_header' },
  emptyDescription: { id: 'wordlists_addedbyme_emptystate_body_copy' },
  exploreVideosButton: { id: 'wordlists_addedbyme_emptystate_CTA' },
  letsGoButton: { id: 'wordlists_viewlist_CTA' },
});

export const EmptyWordlistCard: FC<{ handleWordlistSelection?: () => void }> = ({
  handleWordlistSelection,
}) => {
  const intl = useIntl();
  const { query } = useRouter();
  const isFromChooseWordlist = Boolean(
    query.back && String(query.back).includes('choose-wordlist'),
  );

  return (
    <S.Container>
      <S.Title>{intl.formatMessage(msgs.emptyTitle)}</S.Title>
      <S.Description>{intl.formatMessage(msgs.emptyDescription)}</S.Description>
      {isFromChooseWordlist ? (
        <Button
          buttonSize="large"
          buttonType="primary"
          data-testid="wordlist_switch_btn"
          onClick={handleWordlistSelection}
        >
          {intl.formatMessage(msgs.letsGoButton)}
        </Button>
      ) : (
        <LinkButton
          buttonSize="large"
          buttonType="primary"
          href={ROUTES.video.immerse}
          data-testid="explore-videos-button"
        >
          {intl.formatMessage(msgs.exploreVideosButton)}
        </LinkButton>
      )}
    </S.Container>
  );
};
